import type { InjectionKey, Ref } from "vue";

export type CurrentVerificationDocuments = {
  idFront: any | null;
  idBack: any | null;
  address: any | null;
  selfie: any | null;
};

export const userDocumentsInjectionKeys = {
  canVerifyDocument: Symbol("canVerifyDocument") as InjectionKey<Ref<boolean>>,
  finalizeKyc: Symbol("finalizeKyc") as InjectionKey<Ref<any>>,
  historicalDocuments: Symbol("historicalDocuments") as InjectionKey<
    Ref<Array<any>>
  >,
  isLoading: Symbol("isLoading") as InjectionKey<Ref<boolean>>,
  isShowUserInfos: Symbol("isShowUserInfos") as InjectionKey<Ref<boolean>>,
  kycLoading: Symbol("kycLoading") as InjectionKey<Ref<boolean>>,
  mediaList: Symbol("mediaList") as InjectionKey<Ref<Array<any>>>,
  needSelfie: Symbol("needSelfie") as InjectionKey<Ref<boolean>>,
  otherDocuments: Symbol("otherDocuments") as InjectionKey<Ref<Array<any>>>,
  refreshData: Symbol("refreshData") as InjectionKey<() => Promise<void>>,
  showFinalizedKyc: Symbol("showFinalizedKyc") as InjectionKey<
    () => Promise<void>
  >,
  verificationDetails: Symbol("verificationDetails") as InjectionKey<Ref<any>>,
  verificationDocuments: Symbol("verificationDocuments") as InjectionKey<
    Ref<CurrentVerificationDocuments>
  >,
};
